import React from 'react';
import { Service } from '../types';
import { Card } from './Card';
import { useConfig } from '../context/ConfigContext';

interface ServiceCardProps {
  service: Service;
  onClick?: () => void;
  selected?: boolean;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ service, onClick, selected }) => {
  const { showPrices } = useConfig();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  
  const isClickable = !!onClick;
  
  return (
    <Card 
      hover={isClickable} 
      onClick={onClick ? handleClick : undefined}
      className={`p-6 h-full border-2 transition-all duration-200 relative ${
        selected 
          ? 'ring-4 ring-primary-500 border-primary-500' 
          : isClickable 
            ? 'border-gray-200 hover:border-primary-400 hover:shadow-lg cursor-pointer' 
            : 'border-gray-200'
      }`}
    >
      <div className="flex flex-col items-center text-center h-full">
        <div className="flex items-center gap-2 mb-2">
          {service.serviceIcon && (
            <img 
              src={`https://eitkzk79mdubu4rd.public.blob.vercel-storage.com/icons/${service.serviceIcon}`} 
              alt={service.serviceName}
              className="w-8 h-8 object-contain"
            />
          )}
          <h3 className="text-xl font-bold text-gray-800">{service.serviceName}</h3>
        </div>
        <p className="text-gray-600 text-sm mb-4 flex-grow">{service.serviceDescription}</p>
        
        {showPrices && (
          <div className="w-full border-t border-gray-200 pt-4 mt-2">
            {service.includedItems.length > 0 && (
              <>
                <div className="text-sm text-gray-600 mb-2">Includes:</div>
                <div className="flex flex-wrap gap-2 justify-center mb-4">
                  {service.includedItems.map((item, idx) => (
                    <span key={idx} className="bg-gray-100 px-3 py-1 rounded-full text-xs text-gray-700">
                      {item.count}x {item.name}
                    </span>
                  ))}
                </div>
              </>
            )}
            <div className="text-2xl font-bold text-primary-600 mb-4">₹{service.price}</div>
          </div>
        )}
      </div>
      
      {/* Arrow indicator for clickable cards - positioned at bottom right of the card */}
      {isClickable && (
        <div className="absolute bottom-2 right-2 flex items-center gap-1 text-primary-600 transition-transform duration-200 group-hover:translate-x-1">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </div>
      )}
    </Card>
  );
};
